var script = {
  name: 'PendoTabPanel',
  props: {
    prop: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-tab-panel.vue2.js.map
